import { useEffect, useMemo, useRef } from "react";
import debounce from "lodash/debounce";

export const useDebounce = (callback: () => void, delay: number) => {
  const callbackRef = useRef<() => void>();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      callbackRef.current?.();
    };

    return debounce(func, delay);
  }, [delay]);

  return debouncedCallback;
};
